import React from "react";

const AppML_Includes = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Includes</h1>
      <p>This is the AppML Includes page content.</p>
    </div>
  );
};

export default AppML_Includes;
